import { client } from './client';
import { FieldMetadata, OperatorInfo, MetadataContextType } from '../models/expression';

export const getFieldMetadata = async (contextType: MetadataContextType): Promise<FieldMetadata[]> => {
  const { data } = await client.get<FieldMetadata[]>(`/expressions/field-metadata/${contextType}`);
  return data;
};

export const getOperators = async (): Promise<OperatorInfo[]> => {
  const { data } = await client.get<OperatorInfo[]>('/expressions/operators');
  return data;
};

export const getTokenFields = async (): Promise<FieldMetadata[]> => {
  const { data } = await client.get<FieldMetadata[]>('/expressions/token-fields');
  return data;
};

